import * as React from 'react'

function SlotMenu(props: ComponentSlotProps) {
  return <span />
}

export default SlotMenu